import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import css from './MerchantCouponCalendar.module.scss';
import { useFilterBookingPagesCalendar } from '../../../hooks/fullcalendar';
import { BookingPagesFullCalendarOrganism } from '../../../organisms/FullCalendar/booking-pages';
import { useCouponBookingPageIds } from '../../../hooks/api/coupon';
import { today } from './calendarHelper';

interface ComponentProps {
  merchantPublicId: string;
  merchantTimeZone: string;
  couponPublicId: string;
}

type Props = ComponentProps;

const MerchantCouponCalendar: FC<Props> = ({
  merchantTimeZone,
  merchantPublicId,
  couponPublicId,
}) => {
  const intl = useIntl();
  const baseDate = today(merchantTimeZone).toISO();

  const couponBookingPageIds = useCouponBookingPageIds({
    merchantPublicId,
    couponPublicId,
  });
  const couponFilter = useFilterBookingPagesCalendar(couponBookingPageIds);

  return (
    <div className={css.root}>
      <BookingPagesFullCalendarOrganism
        merchantPublicId={merchantPublicId}
        merchantTimezone={merchantTimeZone}
        filterBookingPagesFunctions={[couponFilter]}
        intl={intl}
        baseDate={baseDate}
      />
    </div>
  );
};

export default MerchantCouponCalendar;
